//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { ProfileMode } from './Enums';

export class PreauthenticationResultItem extends ItemBase {
    ProfileID: string | null = null;
    FirstName: string | null = null;
    LastName: string | null = null;
    EmailAddress: string | null = null;
    ProfileMode: ProfileMode = ProfileMode.Parent;
    MfaRequired: boolean = false;
    OtpRequired: boolean = false;
    SchoolID: string | null = null;
    SchoolName: string | null = null;

    constructor(initializer?: Partial<PreauthenticationResultItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "PreauthenticationResultItem";
}
